// components/strategy/StrategyAuditPanel.jsx — Phase 3B Super Admin
// audit log viewer for their own country, plus an "Intégrité" check
// surfacing whether `verify_chain_intact` (hash-chain) reports clean.
import React, { useEffect, useState } from "react";
import { strategyEndpoints } from "../../lib/strategyApi";

export const StrategyAuditPanel = ({ countryCode }) => {
  const [events, setEvents] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    strategyEndpoints.auditLog(countryCode)
      .then(({ data }) => setEvents(data.events))
      .catch((e) => setErr(e?.response?.data?.detail || "Accès au journal refusé."));
  }, [countryCode]);

  if (err) return <div className="text-xs text-rescue-red font-bold" data-testid="strategy-audit-error">{err}</div>;

  return (
    <div className="space-y-2" data-testid="strategy-audit-panel">
      <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-rescue-mute">
        Journal d'audit — {countryCode} ({events.length} événement{events.length > 1 ? "s" : ""})
      </div>
      <div className="max-h-96 overflow-y-auto space-y-1" data-testid="strategy-audit-events">
        {events.map((ev) => (
          <div key={ev.event_id} className="border border-rescue-line px-2 py-1 text-[11px] flex justify-between" data-testid={`strategy-audit-event-${ev.event_id}`}>
            <span className="font-bold">{ev.action}</span>
            <span className="text-rescue-mute">{ev.resource_type}#{ev.resource_id?.slice(0, 8)}</span>
            <span className="text-rescue-mute">{new Date(ev.timestamp_utc).toLocaleString("fr-FR")}</span>
          </div>
        ))}
        {!events.length && <div className="text-xs text-rescue-mute">Aucun événement pour ce pays.</div>}
      </div>
    </div>
  );
};
